import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react'

export const PostHogPageviewTracker = () => {
  const location = useLocation();
  const posthog = usePostHog()

  useEffect(() => {
    if (posthog) {
      // Capture pageview with additional properties
      posthog.capture('$pageview', {
        path: location.pathname,
        search: location.search,
        url: window.location.href,
        referrer: document.referrer,
        screen_width: window.innerWidth,
        screen_height: window.innerHeight,
        device_type: /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/.test(navigator.userAgent) ? 'mobile' : 'desktop'
      });
    }
  }, [location, posthog]);

  return null;
};

export default PostHogPageviewTracker;